<template>
  <div class="flex w-full h-full">
    <div class="flex flex-col items-center justify-center w-full min-h-full" v-if="!port || !getBerths.length">
      <svg width="320" height="160" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M188.239 10.824a1 1 0 01.722.148l25.633 16.804 5.48-2.055-.727-1.636a1 1 0 011.828-.812l2.316 5.212a1 1 0 01-1.828.812l-.775-1.745-5.337 2.002 3.288 29.316H233a1 1 0 011 1v9.555a1 1 0 01-1 1h-12.195l8.944 12.01a1 1 0 01.183.767l-1.246 7.227h1.129a1 1 0 110 2h-6.659a1 1 0 010-2h3.501l1.102-6.397h-28.232l1.544 6.397h3.555a1 1 0 110 2h-6.948a1 1 0 110-2h1.335l-1.728-7.162a.998.998 0 01.178-.843l9.191-12h-3.186a1 1 0 01-1-1V59.87a1 1 0 011-1h6.071l1.039-7.94-26.465-29.667-12.206 21.156a1 1 0 01-1.832-.756l7.527-28.374c.1-.376.41-.66.793-.728l9.844-1.737zm-3.073 8.614l25.755 28.871 2.476-18.926-24.647-16.158-3.584 6.213zm1.309-6.272l-2.712 4.7-3.254-3.647 5.966-1.053zm-7.416 2.431l3.652 4.094-8.772 15.204 5.12-19.298zm35.335 21.585l-2.838 21.688h5.27l-2.432-21.688zm-5.221 33.243l-8.891 11.607h26.673l-8.644-11.607h-9.138zm-82.272-31.98a1 1 0 011-1h8.107a1 1 0 011 1v4.212h15.793a1 1 0 011 1v2.605c0 .4-.239.762-.606.92l-5.474 2.346v2.104h.447a1 1 0 011 1v3.922h3.054a1 1 0 011 1v1.737c0 .265-.106.52-.293.707l-2.497 2.496c.101.062.19.142.264.238l24.028 30.976h.001c.734.939 1.686 2.35 2.458 3.885.752 1.497 1.396 3.232 1.397 4.803.122 1.759-.416 3.636-1.399 5.519-.994 1.904-2.476 3.878-4.323 5.841-3.694 3.926-8.932 7.894-14.935 11.261-4.634 2.6-9.747 6.943-14.283 11.361-4.525 4.407-8.421 8.836-10.617 11.558a1.002 1.002 0 01-1.64-.121c-1.82-3.095-9.651-12.219-26.03-22.83-8.301-5.379-13.228-10.339-16.004-14.405-2.683-3.929-3.427-7.135-3.087-9.082-.079-1.614.527-3.089 1.278-4.35.625-1.05 1.408-2.039 2.078-2.885.151-.192.298-.377.435-.553 1.618-2.08 16.647-21.459 23.995-30.934l-2.778-2.778a1.002 1.002 0 01-.293-.707v-1.737a1 1 0 011-1h3.054v-3.922a1 1 0 011-1h.737v-2.093l-5.748-2.351a1 1 0 01-.622-.926v-2.605a1 1 0 011-1h15.503v-4.212zm-8.133 11.423v2.764a1 1 0 01-1 1h-.737v8.712h30.137v-8.712h-.447a1 1 0 01-1-1v-2.764h-1.896a1 1 0 01-1-1v-4.211h-6.817a1 1 0 01-1-1v-4.212h-6.107v4.212a1 1 0 01-1 1h-6.238v4.211a1 1 0 01-1 1h-1.895zm.895-5.211h-7.265v.934l5.566 2.277h1.699v-3.211zm25.162 0v3.211h1.69l5.286-2.265v-.946h-6.976zm4.343 16.273v-2.376h2.054v.323l-2.054 2.053zm-34.137 0v-2.376h-2.054v.323l2.054 2.053zm.332 3.414a95523.72 95523.72 0 01-23.731 30.594c-.158.203-.318.406-.48.61-.665.84-1.344 1.7-1.894 2.623-.677 1.138-1.071 2.238-.993 3.318.048.658.274 1.359.794 2.11.231.334.687.781 1.425 1.309.726.521 1.676 1.086 2.84 1.674 2.328 1.175 5.464 2.412 9.274 3.539 7.619 2.254 17.874 4.049 29.647 4.049 11.765 0 22.382-1.938 30.299-4.266 3.959-1.165 7.226-2.422 9.615-3.574 1.195-.577 2.154-1.119 2.864-1.602.736-.501 1.115-.877 1.255-1.097.189-.298.298-.693.302-1.207.007-1.099-.467-2.505-1.184-3.932a22.348 22.348 0 00-2.247-3.552l-.003-.003-23.73-30.593h-34.053zM89.298 106.52a21.45 21.45 0 001.703 2.933c2.587 3.791 7.296 8.578 15.44 13.854 14.901 9.654 22.962 18.193 25.893 22.316 2.321-2.786 5.869-6.74 9.911-10.677 4.574-4.456 9.836-8.944 14.699-11.672 5.868-3.291 10.932-7.141 14.457-10.887 1.763-1.874 3.121-3.7 4.007-5.397l.1-.195c-.702.432-1.534.881-2.48 1.337-2.507 1.21-5.881 2.504-9.92 3.692-8.08 2.376-18.887 4.347-30.863 4.347-11.969 0-22.415-1.824-30.214-4.131-3.898-1.153-7.15-2.431-9.608-3.671-1.229-.621-2.272-1.238-3.104-1.834l-.02-.015zm81.743-60.678a1 1 0 011 1v5.19a8.753 8.753 0 012.382 2.057c.94 1.184 1.652 2.804 1.372 4.765-.171 1.194-.63 2.153-1.31 2.869-.676.71-1.521 1.13-2.387 1.33-1.691.39-3.577-.03-4.823-.92-1.179-.842-1.46-2.08-1.386-3.128.072-1.018.473-1.965.82-2.544a1 1 0 011.715 1.03c-.232.386-.496 1.031-.54 1.654-.042.592.111 1.044.554 1.36.78.558 2.079.86 3.211.6.546-.127 1.022-.377 1.386-.76.361-.38.661-.94.78-1.773.183-1.282-.263-2.364-.959-3.24-.707-.891-1.633-1.51-2.238-1.793a1 1 0 01-.577-.906v-5.79a1 1 0 011-1zm33.427 15.03v7.554H232V60.87h-27.532zm-85.595 7.703a1 1 0 01.324 1.377l-11.291 18.24a1 1 0 01-1.701-1.053l11.292-18.24a1 1 0 011.376-.324zm11.503.85a1 1 0 011-1h1.737a1 1 0 01.132 1.992v5.536h.158a1 1 0 010 2h-.158v8.713h.737a1 1 0 010 2h-.737v20.714a1 1 0 11-2 0V88.665h-.738a1 1 0 010-2h.738v-8.713h-.159a1 1 0 010-2h.159v-5.536a1 1 0 01-.869-.991zm33.588 1.32a1 1 0 011.415 0l52.694 52.694a1 1 0 01-1.415 1.414l-52.694-52.694a1 1 0 010-1.414zm-63.12 21.264a1 1 0 011-1h24.899a1 1 0 110 2h-23.899v10.16h23.899a1 1 0 110 2h-24.899a1 1 0 01-1-1v-12.16zm36.191 0a1 1 0 011-1h24.899a1 1 0 011 1v12.16a1 1 0 01-1 1h-24.899a1 1 0 010-2h23.899v-10.16h-23.899a1 1 0 01-1-1zm-49.363 45.499a1 1 0 011.39.26c.572.837 1.686 2.13 3.113 3.204 1.435 1.081 3.083 1.862 4.747 1.862 1.689 0 3.594-.8 5.36-1.909 1.745-1.097 3.23-2.417 4.048-3.28a1 1 0 011.571.154c.518.82 1.578 2.101 3.021 3.168 1.44 1.066 3.19 1.867 5.109 1.867a1 1 0 010 2c-2.483 0-4.642-1.033-6.299-2.259a15.252 15.252 0 01-2.807-2.711 24.822 24.822 0 01-3.579 2.754c-1.882 1.182-4.175 2.216-6.424 2.216-2.273 0-4.34-1.052-5.95-2.264-1.618-1.218-2.879-2.675-3.56-3.672a1 1 0 01.26-1.39zm89.187.03a1 1 0 01.189 1.401c-1.93 2.533-3.926 4.131-5.926 4.987-2.01.861-3.966.948-5.755.552-2.978-.661-5.452-2.645-7.071-4.534-1.023 1.109-2.349 2.048-3.622 2.792-1.679.981-3.379 1.689-4.452 2.047a1.001 1.001 0 01-.632-1.898c.953-.317 2.525-.97 4.074-1.876 1.569-.916 3.005-2.03 3.806-3.231a1.002 1.002 0 011.646-.026c1.367 1.914 3.814 4.137 6.684 4.773 1.41.313 2.936.247 4.534-.437 1.609-.689 3.347-2.03 5.123-4.361a1 1 0 011.402-.189zM239.113 50.537c.256-.49.86-.679 1.35-.424l24 12.522a1 1 0 01-.926 1.773l-24-12.521a1.001 1.001 0 01-.424-1.35zm37.375 19.5c.256-.49.86-.68 1.35-.424l2.625 1.37a1 1 0 01-.926 1.773l-2.625-1.37a1.001 1.001 0 01-.424-1.349zm14.625 7.63a1 1 0 011.35-.423l17 8.87a1.001 1.001 0 01-.926 1.773l-17-8.87a1 1 0 01-.424-1.35zM248.212 96.384a1 1 0 011.404-.172l32 25a1 1 0 01-1.232 1.576l-32-25a1 1 0 01-.172-1.404z" fill="#DEE3EA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M127.164 48v2.475h5.369V48h-5.369zM121.954 53.213v2.474h5.369v-2.474h-5.369zM136.008 52.63v2.475h5.37v-2.474h-5.37zM136.008 57.265v2.475h5.37v-2.475h-5.37zM60.384 43.212a1 1 0 011.404.171c.793 1.014 2.215 2.189 3.866 2.523 1.547.313 3.495-.07 5.563-2.547.201-.241.491-.364.782-.36a.999.999 0 01.804.384c.793 1.014 2.216 2.189 3.866 2.523 1.547.313 3.495-.07 5.563-2.547a1 1 0 011.536 1.281c-2.468 2.956-5.126 3.706-7.495 3.226-1.764-.357-3.246-1.37-4.278-2.392-2.247 2.262-4.609 2.823-6.737 2.392-2.265-.458-4.067-2-5.045-3.25a1 1 0 01.17-1.404zM31.35 103.239a1 1 0 011.41.111c1.186 1.388 3.342 3.04 5.904 3.515 2.478.46 5.488-.15 8.575-3.539a.998.998 0 01.76-.326c.29-.007.58.113.783.35 1.186 1.388 3.342 3.04 5.904 3.515 2.478.46 5.488-.15 8.575-3.539a1 1 0 011.478 1.347c-3.51 3.855-7.201 4.755-10.418 4.158-2.647-.491-4.866-1.973-6.33-3.404-3.29 3.218-6.696 3.96-9.692 3.404-3.133-.581-5.668-2.552-7.06-4.182a1 1 0 01.112-1.41zM47.384 53.212a1 1 0 011.404.171c.793 1.014 2.215 2.189 3.866 2.523 1.547.313 3.495-.07 5.563-2.547.201-.241.491-.364.782-.36a.999.999 0 01.804.384c.793 1.014 2.216 2.189 3.866 2.523 1.547.313 3.495-.07 5.563-2.547a1 1 0 011.536 1.281c-2.468 2.956-5.126 3.706-7.495 3.226-1.764-.357-3.246-1.37-4.278-2.392-2.247 2.262-4.609 2.823-6.737 2.392-2.265-.458-4.067-2-5.046-3.25a1 1 0 01.172-1.404zM13.35 116.239a1 1 0 011.41.111c1.186 1.388 3.342 3.04 5.904 3.515 2.478.46 5.488-.15 8.575-3.539a.998.998 0 01.76-.326c.29-.007.58.113.784.35 1.185 1.388 3.34 3.04 5.903 3.515 2.478.46 5.488-.15 8.575-3.539a1 1 0 011.478 1.347c-3.51 3.855-7.201 4.755-10.418 4.158-2.647-.491-4.866-1.973-6.33-3.404-3.29 3.218-6.696 3.96-9.692 3.404-3.133-.581-5.668-2.552-7.06-4.182a1 1 0 01.112-1.41z" fill="#DEE3EA"/></svg>
      <h1 class="m-t-4 m-b-2 fz18 fw500">Berth list is empty</h1>
      <button class="fz14 text-blue" @click="isModalAdd = true">Create new</button>
    </div>

    <div class="w-1/3 overflow-y-auto box-border border-r border-gray-light bg-white" v-if="port && getBerths.length">
      <aside-top :name="port.name" @on-add="isModalAdd = true"/>
      <aside-list 
        :list="getBerths" 
        :active="active" 
        @on-select="onSelectBerth"
        @on-archive="onArchive"
      />
    </div>
    <div class="w-2/3 overflow-y-auto box-border" v-if="port && getBerths.length">
      <div class="flex items-center justify-between p-x-6 p-y-4">
        <h2 class="fz18 fw500">Berth Details</h2>
        <div class="fz13 text-gray-text" v-if="active">Last edit {{active.updated_at | formatDate}} at {{active.updated_at | formatTime}} {{active.creator ? 'by '+active.creator.first_name+' '+active.creator.last_name : ''}}</div>
        <div class="fz13 text-gray-text" v-else>Please, choose the berth</div>
      </div>

      <berth class="m-x-6 m-b-4" v-if="active" :berth="active" @on-update="onUpdate" @on-error="onError"/>
    </div>

    <add-modal
      v-if="isModalAdd"
      :isShowModal="isModalAdd"
      @on-close="isModalAdd = false"
      @on-add="onAdd"
    />

    <archive-modal 
      :isShowModal="isModalArchive"
      :berth="archivedBerth"
      @on-close="onCloseModal"
      @on-send="sendArchive"
    ></archive-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import addModal from '@/components/ports/berth/add'
import asideTop from '@/components/ports/berth/asideTop'
import asideList from '@/components/ports/berth/asideList'
import berth from '@/components/ports/berth/berth'
import archiveModal from '@/components/ports/berth/modal'

export default {
  components: {
    addModal,
    asideTop,
    asideList,
    berth,
    archiveModal
  },
  data() {
    return {
      active: null,
      isModalAdd: false,
      isModalArchive: false,
      archivedBerth: null,
      isError: false
    }
  },
  computed: {
    ...mapState({
      port: state => state.ports.openPort
    }),
    getBerths() {
      if(!this.port || !this.port.berths.length) return []
      return this.port.berths.filter(el=>!el.is_archive)
    }
  },
  methods: {
    ...mapActions(['axiosEditBerth']),
    ...mapMutations(['addTip']),
    onSelectBerth(berth) {
      if(this.isError) return false
      this.active = berth
    },
    onError(bool) {
      this.isError = bool
    },
    onAdd(berth) {
      this.port.berths.push(berth)
    },
    async onUpdate(berth) {
      if(this.isError) return false

      if(berth.port.id)
        berth.port = berth.port.id

      let newBerth = await this.axiosEditBerth({...berth})

      let index = this.port.berths.findIndex(el=>{
        return el.id == newBerth.id
      })
      this.port.berths.splice(index, 1, newBerth)
      this.active = newBerth
    },
    onCloseModal() {
      this.isModalArchive = false
      this.archivedBerth = null
    },
    onArchive(berth) {
      if(this.isError && this.active && berth.id == this.active.id) return false
      this.archivedBerth = berth
      this.isModalArchive = true
    },
    async sendArchive() {
      this.archivedBerth.is_archive = true
      this.onUpdate(this.archivedBerth)
      this.addTip(this.archivedBerth.name + ` is archived`)
      if(this.active && this.active.id == this.archivedBerth.id){
        if(this.getBerths.length) this.active = this.getBerths[0]
        else this.active = null
      }
      this.archivedBerth = null
      this.isModalArchive = false
    }
  },
  beforeMount() {
    if(!this.active)
      this.onSelectBerth(this.getBerths[0])
  }
}
</script>

<style lang="scss">
.berths_table__wrap{
  &.active,
  &:hover{
    color: var(--color-blue-dark);
    button{
      opacity: 1;
      visibility: visible;
    }
  }
  &.active{
    background-color: var(--color-gray-darkest);
  }
}
.berths_table{
  display: flex;
  align-items: center;
  &__item{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    &:nth-child(1){
      width: 37.8%;
      padding-right: 1.1rem;
    }
    &:nth-child(2){
      width: 31.3%;
      padding-right: 1rem;
    }
    &:nth-child(3){
      width: 24.4%;
    }
    &:nth-child(4){
      width: 6.5%;
    }
    button{
      opacity: 0;
      visibility: hidden;
    }
  }
}
.contacts_table{
  &__item{
    &:nth-child(1){
      width: 17.5%;
      padding-right: 1rem;
    }
    &:nth-child(2){
      width: 28%;
      padding-right: 1rem;
    }
    &:nth-child(3){
      width: 11.8%;
      padding-right: 0.5rem;
    }
    &:nth-child(4){
      width: 17.5%;
      padding-right: 0.75rem;
    }
    &:nth-child(5){
      width: 20.3%;
    }
    &:nth-child(6){
      width: 4.8%;
    }
  }
}
</style>